!function () {
  function hide(el) {
    if (el) {
      el.style.display = "none";
      el.style.opacity = "0";
    }
  }

  function init() {
    var overlay = document.querySelector(".pop-up-final-outer");
    var panel = document.querySelector(".pop-up-quiz-con");
    if (!overlay || !panel) return;

    // Homepage quiz CTA links to /pages/skincare-quiz — do not open the overlay.
    // Keep close handlers in case the overlay is shown from elsewhere.
    document.addEventListener("click", function (e) {
      if (e.target.closest(".close-icon")) hide(overlay);
    });
    document.addEventListener("mouseup", function (e) {
      if (!panel.contains(e.target) && e.target !== panel) hide(overlay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}();
